// When using a bundler such as Webpack,
// include both noUiSlider and its stylesheet.
// Either import the default:
import * as noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';

window.addEventListener('load', function() {
    var slider = document.getElementById('slider');

    if (slider) {
        noUiSlider.create(slider, {
            start: [0, 3500],
            connect: true,
            direction: 'ltr', // valeur maximale à gauche, valeur minimale à droite
            range: {
                min: 500,
                max: 3500,
            },
            tooltips: true,
            format: {
                to: function(value) {
                    return Math.round(value);
                },
                from: function(value) {
                    return Number(value);
                },
            },
        });
    }
});

/**
 * External Dependencies
 */

// Select all links with hashes
$('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
        // On-page links
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $('html, body').animate(
                    {
                        scrollTop: target.offset().top,
                    },
                    1000,
                    function() {
                        // Callback after animation
                        // Must change focus!
                        var $target = $(target);
                        $target.focus();
                        if ($target.is(':focus')) {
                            // Checking if the target was focused
                            return false;
                        } else {
                            $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                            $target.focus(); // Set focus again
                        }
                    }
                );
            }
        }
    });

/**
 * Nav > Menu Hamburger > Show/hide
 */
jQuery('header.containMenu nav.mobile.menu span.toggleMenuMobile').on('click', function() {
    jQuery('header.containMenu nav.mobile.menu.deployed').slideDown();
});

jQuery('header.containMenu nav.mobile.menu.deployed span.actionClose').on('click', function() {
    jQuery('header.containMenu nav.mobile.menu.deployed').slideUp();
});

/**
 * BLOC - EntêteDePage - Slider
 */

import Swiper from 'swiper/bundle';
window.Swiper = Swiper;
var mySwiper = new Swiper('.swiper-container', {
    direction: 'horizontal',
    loop: true,
    speed: 1100,
    parallax: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function(index, className) {
            return '<span class="' + className + ' cursor-pointer w-4 mb-3 dot"></span>';
        },
    },
    autoplay: {
        delay: 4000,
    },
});

if (document.querySelector('.swiper-container-bandeau')) {
    new Swiper('.swiper-container-bandeau', {
        loop: true,
        autoplay: {
            delay: 5000,
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });
}

/**
 * Sticky Header
 */

let navbar = document.querySelector('header.containMenu');
let shouldStickPosition = 1; // At 1px, stick the position of the var 'navbar'

function addOrRemoveStickyClass() {
    if (window.pageYOffset >= shouldStickPosition) {
        navbar.classList.add('sticky');
        navbar.classList.remove('absolute');
    } else {
        navbar.classList.remove('sticky');
        navbar.classList.add('absolute');
    }
}

window.onscroll = () => {
    addOrRemoveStickyClass();
};

window.onresize = () => {
    shouldStickPosition = 1;
};

/* Bloc - Avantages */
// Initialisation du Swiper
var swiperAvantages = new Swiper('.swiper-avantages', {
    // Configuration des options du Swiper
    loop: true,
    // slidesPerView: 'auto',
    // centeredSlides: true,
    spaceBetween: 30,
    grabCursor: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-arrow-right',
        prevEl: '.swiper-arrow-left',
    },
});

document.querySelectorAll('.swiper-container-galerie').forEach(function(el) {
    var parent = el.closest('.bloc-galerie-images');
    new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 30,
        grabCursor: true,
        pagination: {
            el: parent ? parent.querySelector('.swiper-pagination') : '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: parent ? parent.querySelector('.button-next-custom') : '.button-next-custom',
            prevEl: parent ? parent.querySelector('.button-prev-custom') : '.button-prev-custom',
        },
    });
});

// Galerie popup swiper (unique selectors to avoid conflict with SYSC plugin)
var galeriePopupSwiper = null;

// Close galerie popup on X button click or overlay
jQuery(document).on('click', '#close-galerie-popup, .galerie-popup-overlay', function() {
    jQuery('#galerie-popup').fadeOut();
});

// Close galerie popup on ESCAPE key
jQuery(document).on('keydown', function(event) {
    if (event.keyCode === 27 && jQuery('#galerie-popup').is(':visible')) {
        jQuery('#galerie-popup').fadeOut();
    }
});

// Function to open galerie popup and navigate to specific slide
window.generatePopupSwiper = function(index) {
    // Show popup first so Swiper can calculate dimensions
    jQuery('#galerie-popup').fadeIn(function() {
        // Initialize Swiper after popup is visible
        if (!galeriePopupSwiper && document.querySelector('.galerie-popup-swiper')) {
            galeriePopupSwiper = new Swiper('.galerie-popup-swiper', {
                slidesPerView: 1,
                spaceBetween: 30,
                navigation: {
                    nextEl: '.galerie-popup-next',
                    prevEl: '.galerie-popup-prev',
                },
                on: {
                    slideChange: function() {
                        var currentSlideIndex = this.realIndex + 1;
                        var totalSlides = this.slides.length;
                        jQuery('.galerie-indication').text(currentSlideIndex + '/' + totalSlides);
                    }
                }
            });
        }

        if (!galeriePopupSwiper) return;

        galeriePopupSwiper.slideTo(index);

        // Update slide indicator
        var currentSlideIndex = galeriePopupSwiper.realIndex + 1;
        var totalSlides = galeriePopupSwiper.slides.length;
        jQuery('.galerie-indication').text(currentSlideIndex + '/' + totalSlides);
    });
};

/**
 * BLOC - Icônes
 */

const swiper = new Swiper('.icones-swiper-container', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    speed: 1100,
    parallax: true,
    autoplay: {
        delay: 4000,
    },
    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
});

// Initialiser Fancybox seulement si des éléments existent
if (document.querySelectorAll('[data-fancybox]').length > 0) {
    Fancybox.bind('[data-fancybox]', {
        hideScrollbar: false,
        placeFocusBack: false,
        trapFocus: false
    });
}

/**
 * BLOC - Thumbnails
 */

var thumbSwiper = new Swiper('.articles-vedettes-swiper-container, .thumbnails-projet-swiper-container', {
    slidesPerView: 1,
    spaceBetween: 10,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    // Responsive breakpoints
    breakpoints: {
        640: {
            slidesPerView: 2,
            spaceBetween: 50,
        },
        // when window width is >= 1024px
        1024: {
            slidesPerView: 3,
            spaceBetween: 50,
        },
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

var thumbSwiper = new Swiper('.thumbnails-swiper-container', {
    slidesPerView: 1,
    spaceBetween: 10,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    // Responsive breakpoints
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 50,
        },
        // when window width is >= 1024px
        1024: {
            slidesPerView: 3,
            spaceBetween: 50,
        },
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    autoplay: {
        delay: 2000, // défile toutes les 2 secondes
        disableOnInteraction: false,
    },
});

/**
 * BLOC - Liste partenaires
 */

var thumbSwiper = new Swiper('.partenaires-swiper-container', {
    slidesPerView: 3,
    spaceBetween: 30,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    // Responsive breakpoints
    breakpoints: {
        // when window width is >= 480px
        0: {
            slidesPerView: 1,
            spaceBetween: 30,
        },
        // when window width is >= 640px
        640: {
            slidesPerView: 2,
            spaceBetween: 50,
        },
        // when window width is >= 1024px
        800: {
            slidesPerView: 4,
            spaceBetween: 50,
        },
    },
    navigation: {
        // nextEl: '.swiper-button-next',
        // prevEl: '.swiper-button-prev',
    },
});

/**
 * BLOC - Schéma séquentiel
 */

function giveHeightToTheConnector() {
    jQuery('div.acf-schema-sequentiel div.connector').each(function() {
        /* Get 'height' from the parent, .bloc */
        let heightParent = jQuery(this).closest('div.bloc').innerHeight();

        /* Get 'padding-bottom' from the parent, .bloc ... ? */

        /* Apply the height to the connector */
        jQuery(this).height(heightParent);
    });
}

window.addEventListener('resize', function() {
    giveHeightToTheConnector();
});

giveHeightToTheConnector();

/**
 * BLOG - MOBILE - Menu
 */

// Chargement de la page en fonction du choix
jQuery('select#blogMenuMobile').on('change', function() {
    let selectedCategoryUrl = jQuery(this).find('option:selected').val();
    window.location.href = selectedCategoryUrl;
});

/**
 * GSAP
 */

// Déclaration de ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

// Exemple
/* gsap.from('footer', {
    scrollTrigger: 'footer',
    opacity: 0,
    duration: 10,
    scale: 0
})
*/

jQuery('.swiper-testimonial-container p, .swiper-testimonial-container h3, .swiper-testimonial-container div.testimonial-job').addClass('no-animation');

gsap.utils
    .toArray('p, h1, h2, h3, h4, .h1, .h2, .h3, .h4, .button, div.videoContainer')
    .filter((item) => !item.classList.contains('no-animation'))
    .forEach((item) => {
        gsap.from(item, {
            scrollTrigger: {
                trigger: item,
                toggleActions: 'play none none none',
                start: 'top 95%',
                immediateRender: true,
            },
            opacity: 0,
            y: -10,
            duration: 0.5,
        });
    });

// Sélectionnez tous les éléments avec la classe "group"
const groups = document.querySelectorAll('div.bloc-en-tete-accueil .group');

// Masquez les éléments avec CSS
/*groups.forEach(element => {
    element.style.opacity = 0;
});*/

// Parcourez chaque élément et ajoutez une animation à chacun
groups.forEach((group, index) => {
    // Utilisez la méthode `fromTo` de GSAP pour animer l'opacité de 0 à 1
    gsap.fromTo(
        group,
        {
            opacity: 0,
        },
        {
            opacity: 1,
            duration: 0.2,
            delay: index * 0.2 + 0.6,
        }
    );
});

// Bloc Thumbnails
const thumb = document.querySelectorAll('div.bloc-thumbnails .thumbnail.swiper-slide');

// Parcourez chaque élément et ajoutez une animation à chacun
thumb.forEach((group, index) => {
    // Utilisez la méthode `fromTo` de GSAP pour animer l'opacité de 0 à 1
    gsap.fromTo(
        group,
        {
            opacity: 0,
        },
        {
            opacity: 1,
            duration: 0.2,
            delay: index * 0.2 + 0.6,
            scrollTrigger: {
                trigger: document.querySelectorAll('div.bloc-thumbnails'),
                toggleActions: 'play',
                start: 'top 80%',
                immediateRender: true,
            },
        }
    );
});

// Bloc Image icônes
const ico = document.querySelectorAll('div.bloc-images-icones div.icones > div.flex');

// Parcourez chaque élément et ajoutez une animation à chacun
ico.forEach((group, index) => {
    // Utilisez la méthode `fromTo` de GSAP pour animer l'opacité de 0 à 1
    gsap.fromTo(
        group,
        {
            opacity: 0,
        },
        {
            opacity: 1,
            duration: 0.2,
            delay: index * 0.2 + 0.6,
            scrollTrigger: {
                trigger: document.querySelectorAll('div.bloc-images-icones'),
                toggleActions: 'play',
                start: 'top 80%',
                immediateRender: true,
            },
        }
    );
});

// Bloc FAQ
const faq = document.querySelectorAll('div.bloc-faq');

// Parcourez chaque élément et ajoutez une animation à chacun
faq.forEach((group, index) => {
    // Utilisez la méthode `fromTo` de GSAP pour animer l'opacité de 0 à 1
    gsap.fromTo(
        group,
        {
            opacity: 0,
        },
        {
            opacity: 1,
            duration: 0.2,
            delay: index * 0.2 + 0.6,
            scrollTrigger: {
                trigger: document.querySelectorAll('div.bloc-faq'),
                toggleActions: 'play',
                start: 'top 80%',
                immediateRender: true,
            },
        }
    );
});

// Bloc infolettre
const infolettre = document.querySelectorAll('div.bloc-infolettre');

// Parcourez chaque élément et ajoutez une animation à chacun
infolettre.forEach((group, index) => {
    // Utilisez la méthode `fromTo` de GSAP pour animer l'opacité de 0 à 1
    gsap.fromTo(
        group,
        {
            opacity: 0,
        },
        {
            opacity: 1,
            duration: 0.2,
            delay: index * 0.2 + 0.6,
            scrollTrigger: {
                trigger: document.querySelectorAll('div.bloc-infolettre'),
                toggleActions: 'play',
                start: 'top 80%',
                immediateRender: true,
            },
        }
    );
});

/*
Bloc chiffres-clés - Fonction affichant un compteur
*/
function autoCount() {
    jQuery('.counter span').each(function() {
        jQuery(this)
            .prop('Counter', 0)
            .animate(
                {
                    Counter: parseInt(jQuery(this).data('to')),
                },
                {
                    duration: 2800,
                    easing: 'swing',
                    step: function(now) {
                        jQuery(this).text(
                            Math.ceil(now)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
                        );
                    },
                }
            );
    });
}

jQuery(document).ready(function() {
    // Toggle Open/Close QR
    jQuery('div.qr-item').on('click', function() {
        jQuery(this).find('div.question').next().slideToggle();
        jQuery(this).find('span.toggleAction span').toggleClass('hidden');
    });

    // Smooth scroll to category title on click
    jQuery('.bloc-faq nav#faq-nav ul.flex li').on('click', function() {
        var category = jQuery(this).text().toLowerCase().replace(/\s+/g, '-');
        var target = jQuery('.questionsReponses#' + category);
        var header = jQuery('header').innerHeight();

        jQuery('.bloc-faq nav#faq-nav ul li').removeClass('active').addClass('inactive');
        jQuery(this).addClass('active');

        jQuery('html, body').animate(
            {
                scrollTop: target.offset().top - jQuery('nav').outerHeight() - header,
            },
            1000
        );
    });

    ScrollTrigger.create({
        trigger: '.bloc-chiffres-cles .chiffresClesContainer',
        start: 'top 100%',
        toggleActions: 'play none none reverse',
        onEnter: function() {
            autoCount();
        },
    });
});

var testimonialSlider = new Swiper('.bloc-temoignages .swiper-testimonial-container', {
    // Ajouter les options de configuration ici, par exemple :
    loop: true,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    // Autres options de configuration ici...
});

const carrouselSlider = new Swiper('.swiper-bloc-carrousel', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false,
    },
    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

    // And if we need scrollbar
    scrollbar: {
        el: '.swiper-scrollbar',
    },
});

const imageGaucheDroiteSlider = new Swiper('.swiper-bloc-image-gauche-droite', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

    // And if we need scrollbar
    scrollbar: {
        el: '.swiper-scrollbar',
    },
});

// Initialise un nouveau Swiper avec la classe '.swiper-bloc-images-icones'
const imagesIconesSlider = new Swiper('.swiper-bloc-images-icones', {
    // Paramètres optionnels
    direction: 'horizontal', // Définit la direction du slider ('horizontal' par défaut)
    loop: true, // Active ou désactive la lecture en boucle du slider (désactivé par défaut)
    autoplay: {
        // Paramètres pour activer la lecture automatique du slider
        delay: 5000, // Délai entre chaque transition de slide en millisecondes (3000 par défaut)
        disableOnInteraction: false, // Désactive l'autoplay lorsque l'utilisateur interagit avec le slider (activé par défaut)
    },
    // Si on veut ajouter une pagination
    pagination: {
        el: '.swiper-pagination', // Elément HTML où sera ajoutée la pagination (null par défaut)
        clickable: true, // Active la possibilité de cliquer sur la pagination pour changer de slide (false par défaut)
    },

    // Flèches de navigation
    navigation: {
        nextEl: '.swiper-button-next', // Elément HTML pour la flèche suivante (null par défaut)
        prevEl: '.swiper-button-prev', // Elément HTML pour la flèche précédente (null par défaut)
    },

    // Si on veut ajouter une scrollbar
    scrollbar: {
        el: '.swiper-scrollbar', // Elément HTML où sera ajoutée la scrollbar (null par défaut)
    },
});

// Fonction pour ajuster la hauteur des swiper-slide en fonction du plus grand élément dans chaque conteneur
function setSlideHeight() {
    // Boucle sur chaque conteneur .thumbnails-swiper-container
    $('.thumbnails-swiper-container').each(function() {
        // Initialise la hauteur maximale à 0
        var maxHeight = 0;

        // Boucle sur chaque slide dans le conteneur actuel
        $(this)
            .find('.swiper-slide')
            .each(function() {
                // Réinitialise la hauteur du slide
                $(this).css('height', 'auto');

                // Calcule la hauteur actuelle du slide
                var slideHeight = $(this).height();

                // Met à jour la hauteur maximale si la hauteur actuelle est supérieure
                maxHeight = slideHeight > maxHeight ? slideHeight : maxHeight;
            });

        // Applique la hauteur maximale à tous les slides dans le conteneur actuel
        $(this).find('.swiper-slide').height(maxHeight);
    });
}

// Appelle la fonction setSlideHeight() au chargement de la page et à chaque redimensionnement de la fenêtre
$(window).on('load resize', function() {
    // setSlideHeight();
});

window.onload = function() {
    // Code pour la page "single-condos"
    if (jQuery('div.activeCampaign.condos, div.activeCampaign.phasesProjet').length) {
        var projet_titre = jQuery('#projet_titre').text();
        jQuery('input[data-name=projet_immobilier_choisi]').val(projet_titre);

        var unite_titre = jQuery('#unite_titre').text();
        jQuery('input[data-name=unit_choisie]').val(unite_titre);
    }

    // Code pour la page "single-projets"
    if (jQuery('section.single-projet').length) {
        jQuery('#tooltip').hide();

        // Ajout d'un setTimeOut pour corriger le bug de la valeur du jQuery(this).text (qui affiche parfois, par exemple, "Poly 1" à la place de "Étage 1")
        // setTimeout(() => {//

        // Récupérer tous les éléments h3 dans les tooltips

        // Le sélecteur pour desktop
        var desktopSelector = 'div.imp-tooltips-container .imp-tooltip h3';
        // Le sélecteur pour mobile
        var mobileSelector = 'div.imp-fullscreen-tooltips-container div.imp-fullscreen-tooltip h3';

        // On essaie dabord avec le sélecteur de desktop
        var h3s = jQuery(desktopSelector);

        // Si aucun élément h3 n'est trouvé avec le premier sélecteur, on essaie avec le deuxième
        if (h3s.length === 0) {
            h3s = jQuery(mobileSelector);
        }

        // Parcourir chaque élément h3
        h3s.each(function() {
            // Récupérer le texte de l'élément h3
            var text = jQuery(this).text();

            if (text.toLowerCase().includes('étage')) {
                // Créer une nouvelle div avec le texte de l'élément h3
                var newDiv = jQuery(
                    '<div data-tooltip="" data-name="' +
                    text
                        .toLowerCase()
                        .normalize('NFD')
                        .replace(/[̀-ͯ]/g, '')
                        .replace(/\s+/g, '-') + // Corrected regex escape
                    '" class="item divLevel">'
                ).text(text);

                // Ajouter la nouvelle div à la fin de la div "imagePro"
                jQuery('div#imagePro div.nav').prepend(newDiv).removeClass('opacity-0').addClass('opacity-1');
            }
        });

        // Le code ci-dessous vérifie que l'ordre d'affichage des etage-X soient bien respectés en ordre décroissant

        var nav = jQuery('div.navWrapper .nav');
        var items = nav.children('.item').detach();

        items.sort(function(a, b) {
            var an = parseInt(jQuery(a).data('name').split('-')[1]);
            var bn = parseInt(jQuery(b).data('name').split('-')[1]);
            return bn - an;
        });

        nav.append(items);

        // }, 0);

        // Attacher des gestionnaires dévénements aux éléments de navigation
        jQuery(document).on('mouseenter', 'div#imagePro div.nav div.item', function() {
            var name = jQuery(this).data('name');
            jQuery('div#imagePro polygon[data-shape-title="' + name + '"]').addClass('hovered');
        });

        jQuery(document).on('mouseleave', 'div#imagePro div.nav div.item', function() {
            var name = jQuery(this).data('name');
            jQuery('div#imagePro polygon[data-shape-title="' + name + '"]').removeClass('hovered');
        });

        // Ajout des gestionnaires dévénements pour les éléments polygon
        jQuery(document).on('mouseenter', 'div#imagePro polygon', function() {
            var name = jQuery(this).data('shape-title');

            var tooltipText = jQuery(this).data('shape-tooltip');
            var tooltip = jQuery('#tooltip');
            tooltip.text(tooltipText);
            tooltip.css({
                top: event.pageY + 10,
                left: event.pageX + 10,
            });
            tooltip.show();

            jQuery('div#imagePro div.nav div.item[data-name="' + name + '"]').addClass('hovered');
        });

        jQuery(document).on('mouseleave', 'div#imagePro polygon', function() {
            var name = jQuery(this).data('shape-title');

            var tooltip = jQuery('#tooltip');
            tooltip.hide();

            jQuery('div#imagePro div.nav div.item[data-name="' + name + '"]').removeClass('hovered');
        });

        jQuery(document).on('click', 'div#imagePro div.nav div.item, div#imagePro polygon.imp-shape', function() {
            /* Récupération de lidentifiant de létage | Comme le déclenchement du click peut se faire sur 2 éléments, on sassicure de récupérer la bonne information */
            var id_1 = jQuery(this).data('name');
            var id_2 = jQuery(this).data('shape-title');
            var etage_id = (id_1 !== undefined ? id_1 : '') + (id_2 !== undefined ? id_2 : '');

            // On masque tous les etage-item au chargement de la lightbox
            jQuery('div.etage-item').hide();

            // Puis, on charge celle qui contient lID de létage que lon souhaite voir
            jQuery('div.etage-item[data-etage-name="' + etage_id + '"]').show();

            // Afficher la boîte de dialogue de létage correspondant
            jQuery('div#lightbox-etages').fadeIn();

            // Sélectionner "Tous" par défaut à l'ouverture
            jQuery('div#filter-type div.item').removeClass('active');
            jQuery('div#filter-type div.item[data-slug="all"]').addClass('active');
            typeSelectionne = [];
            showAllTypes = true;
            filterEtages(fourchetteSelectionne, typeSelectionne);

            // Masquage de la barre de scroll du body
            jQuery('body').toggleClass('overflow-y-hidden');
        });

        function fermerLightbox() {
            jQuery('div#lightbox-etages').fadeToggle();
            jQuery('body').toggleClass('overflow-y-hidden');
        }

        jQuery(document).on('keydown', function(event) {
            if (event.keyCode === 27) {
                fermerLightbox();
            }
        });

        jQuery('div#lightbox-etages div.close, div#lightbox-etages a.closeLightbox').on('click', function() {
            fermerLightbox();
        });

        jQuery(document).on('mousemove', function(event) {
            var tooltip = jQuery('#tooltip');
            if (tooltip.is(':visible')) {
                tooltip.css({
                    top: event.pageY - 50,
                    left: event.pageX + 10,
                });
            }
        });

        jQuery(document).on('mouseenter', '.imp-shape-poly', function() {
            jQuery(this).addClass('imp-shape-highlighted');
        });

        jQuery(document).on('mouseleave', '.imp-shape-poly', function() {
            jQuery(this).removeClass('imp-shape-highlighted');
        });

        /************************************* SYSTÈME DE FILTRE **************************************/

        /* Déclaration des variables de base pour le filtre */
        var typeSelectionne = [];
        var fourchetteSelectionne;
        var showAllTypes = true; // Flag pour "Tous"
        /* Variable principale récupérant toutes les informations pour chaque condo */
        var condosParEtage = JSON.parse(jQuery('span#condosParEtageJson').text());

        // console.log(condosParEtage);

        // Filtre > Type - Attribution d'une classe active au click & attribution du type à la variable de filtre
        jQuery(document).on('click', 'div#filter-type div.item', function() {
            const clickedSlug = jQuery(this).data('slug');
            const type = jQuery(this).text().trim();
            
            // Cas 1: Clic sur "Tous"
            if (clickedSlug === 'all') {
                if (!jQuery(this).hasClass('active')) {
                    // Activer "Tous", désactiver les autres
                    jQuery('div#filter-type div.item').removeClass('active');
                    jQuery(this).addClass('active');
                    typeSelectionne = [];
                    showAllTypes = true;
                }
                // Si déjà actif, on ne fait rien (on ne peut pas désélectionner "Tous" directement)
            } 
            // Cas 2: Clic sur un type spécifique
            else {
                // Désactiver "Tous"
                jQuery('div#filter-type div.item[data-slug="all"]').removeClass('active');
                showAllTypes = false;
                
                jQuery(this).toggleClass('active');
                
                const index = typeSelectionne.indexOf(type);
                if (index > -1) {
                    typeSelectionne.splice(index, 1);
                } else {
                    typeSelectionne.push(type);
                }
                
                // Si plus aucun type sélectionné, réactiver "Tous"
                if (typeSelectionne.length === 0) {
                    jQuery('div#filter-type div.item[data-slug="all"]').addClass('active');
                    showAllTypes = true;
                }
            }
            
            // Mise à jour de l'affichage des étages
            filterEtages(fourchetteSelectionne, typeSelectionne);
        });

        // Filtre > Prix - Attribution de la fourchette à la variable de filtre
        slider.noUiSlider.on('update', function(values) {
            fourchetteSelectionne = values;

            // Mise à jour de laffichage des étages
            filterEtages(fourchetteSelectionne, typeSelectionne);
        });

        // Fonction centrale qui permet de filtrer laffichage des étages - Est utilisé à plusieurs endroits
        function filterEtages(fourchette, type, arrayCondos) {
            // console.log(type) // "type" est sous la forme "['4 1/2', '5 1/2']"
            // console.log(fourchette) // "fourchette" est sous la forme "[500, 3500]", où pour lexemple, 500 est le minimum et 3500 le maximum

            // Attribution du code couleur (disponible / disponible prochainement / non-disponible) pour chaque étage
            jQuery('.etage-item').each(function() {
                const etageName = jQuery(this).data('etage-name');
                const etage = condosParEtage[etageName];
                if (etage) {
                    const condos = etage.condos;
                    Object.keys(condos).forEach((condoKey) => {
                        const condo = condos[condoKey];
                        const condo_prix = parseInt(condo.prix);
                        const condo_disponible = condo.disponibilite === 'oui';
                        const condo_disponible_prochainement = condo.disponibilite_prochaine === 'oui';
                        const condo_type = condo.type; // "condo_type" est sous la forme '4 1/2'
                        const isTypeValide = showAllTypes || type.includes(condo_type);
                        const isPrixValide = condo_prix >= parseInt(fourchette[0]) && condo_prix <= parseInt(fourchette[1]);
                        const polygon = jQuery(`polygon[data-shape-title="${condo.id}"]`, this);

                        // console.log(condo.id + ' | Le prix du condo est ' + condo_prix + ' | La fourchette est ' + fourchette[0] + ' - ' + fourchette[1] + ' | isPrixValide : ' + isPrixValide + ' | isTypeValide ' + isTypeValide + ' | condo_disponible : ' + condo_disponible)

                        if (polygon.length) {
                            // Cas 1: Non disponible, mauvais type ou mauvais prix = Rouge
                            if ((!condo_disponible && !condo_disponible_prochainement) || !isTypeValide || !isPrixValide) {
                                polygon.addClass('fill-red').removeClass('fill-green fill-yellow');
                            } 
                            // Cas 2: Disponible prochainement = Jaune
                            else if (condo_disponible_prochainement) {
                                polygon.addClass('fill-yellow').removeClass('fill-green fill-red');
                            } 
                            // Cas 3: Disponible = Vert
                            else if (condo_disponible) {
                                polygon.addClass('fill-green').removeClass('fill-red fill-yellow');
                            }
                        }
                    });
                }
            });
        }

        // Boucler sur chaque étage
        for (var etage in condosParEtage) {
            // Récupérer le nombre de condos disponibles pour létage
            var nbCondosDisponibles = condosParEtage[etage]['condos-disponibles'];

            // Sélectionner le polygon correspondant à létage
            var polygon = jQuery('polygon[data-shape-title="' + etage + '"]');
            var polygonLabel = jQuery('div.divLevel');

            // Ajouter le texte du tooltip si le polygon existe
            if (polygon.length > 0) {
                var condosDisponiblesLabel = nbCondosDisponibles + ' condo' + (nbCondosDisponibles > 1 ? 's' : '') + ' disponible' + (nbCondosDisponibles > 1 ? 's' : '');
                polygon.attr('data-shape-tooltip', condosDisponiblesLabel);
                polygonLabel.attr('data-tooltip', condosDisponiblesLabel);
            }
        }

        /************************************* FIN DU SYSTÈME DE FILTRE **************************************/

        // Lightbox > Plan > Au click sur mètre ou pied carré, on charge linformation correspondante
        jQuery('div.selector span.mesure').on('click', function() {
            jQuery('div.selector span.mesure').toggleClass('active');

            let mesureActive = jQuery('div.selector span.mesure.active').data('type');

            jQuery('div.superficieInfo span.mesure').addClass('hidden');
            jQuery('div.superficieInfo span.mesure.' + mesureActive).removeClass('hidden');
        });

        // Lightbox > Plan > Au click sur un polygon qui a un ID, on affiche létage viewer
        jQuery(document).on('click', 'div.etage-item polygon.imp-shape', function(e) {
            // Skip click on unavailable (red) polygons
            if (jQuery(this).hasClass('fill-red')) {
                e.stopPropagation();
                e.preventDefault();
                return false;
            }

            var condoId = $(this).attr('data-shape-title');
            // console.log('Condo ID: ' + condoId);

            // Récupération des informations dun condo pour pouvoir afficher les informations dans le "condo viewer"
            var condoInfo = [];
            for (var etage in condosParEtage) {
                if (condosParEtage.hasOwnProperty(etage)) {
                    var condos = condosParEtage[etage].condos;
                    // console.log(condos)
                    for (var key in condos) {
                        if (condos[key].id == condoId) {
                            var condoInfo = {};
                            condoInfo['id'] = condos[key].id;
                            condoInfo['prix'] = condos[key].prix;
                            condoInfo['type'] = condos[key].type;
                            if (condos[key].disponibilite_prochaine === 'oui') {
                                condoInfo['disponibilite_flag'] = 'prochainement';
                                // Si une date est disponible, l'ajouter au libellé
                                if (condos[key]['disponibilite_date'] && condos[key]['disponibilite_date'] !== '') {
                                    condoInfo['disponibilite'] = 'Disponible prochainement - ' + condos[key]['disponibilite_date'];
                                } else {
                                    condoInfo['disponibilite'] = 'Disponible prochainement';
                                }
                            } else if (condos[key].disponibilite === 'oui') {
                                condoInfo['disponibilite_flag'] = 'disponible';
                                condoInfo['disponibilite'] = 'Disponible';
                            } else {
                                condoInfo['disponibilite_flag'] = 'non_disponible';
                                condoInfo['disponibilite'] = 'Non disponible';
                            }
                            condoInfo['projet-id'] = condos[key]['projet-id'];
                            condoInfo['image_map_id'] = condos[key].image_map_id;
                            condoInfo['nom-unite'] = condos[key]['nom-unite'];
                            condoInfo['superficie_metres'] = condos[key].superficie_metres;
                            condoInfo['superficie_pieds'] = condos[key].superficie_pieds;
                            condoInfo['plan_id'] = condos[key].plan_id;
                            condoInfo['plan_url'] = condos[key].plan_url;
                            condoInfo['single_projet_url'] = condos[key].single_projet_url + '?disponibilite=' + condos[key].disponibilite;
                            condoInfo['visite_virtuelle_url'] = condos[key].visite_virtuelle_url;
                            break;
                        }
                    }
                }
                if (!$.isEmptyObject(condoInfo)) {
                    break;
                }
            }

            // console.log('Condo Info: ', condoInfo);

            // Attribution dynamique des valeurs dans le "condo viewer"
            $('span.valuePrix').text(new Intl.NumberFormat('fr-CA').format(condoInfo['prix']));
            $('span.valueType').text(condoInfo['type']);
            $('span.valueDisponibilite').text(condoInfo['disponibilite']);

            if (condoInfo['disponibilite_flag'] === 'disponible') {
                $('div.avalaible').addClass('bg-green-light').removeClass('bg-nondispo bg-yellow-condo');
            } else if (condoInfo['disponibilite_flag'] === 'prochainement') {
                $('div.avalaible').addClass('bg-yellow-condo').removeClass('bg-green-light bg-nondispo');
            } else {
                $('div.avalaible').addClass('bg-nondispo').removeClass('bg-green-light bg-yellow-condo');
            }

            $('span.valueTitre').text(condoInfo['nom-unite']);
            $('span.valueSuperficieMetres').text(condoInfo['superficie_metres']);
            $('span.valueSuperficiePieds').text(condoInfo['superficie_pieds']);
            $('span.valuePlan').html('<img src="' + condoInfo['plan_url'] + '">');
            $('a.valueUrl').attr('href', condoInfo['single_projet_url']);
            $('footer.visite_virtuelle a').attr('href', condoInfo['visite_virtuelle_url']);
            $('footer.en_savoir_plus a').attr('href', condoInfo['single_projet_url']);

            // console.log('Visite virtuelle URL: début |' + condoInfo['visite_virtuelle_url'] + '| fin');

            if (condoInfo['visite_virtuelle_url'] == '') {
                $('footer.visite_virtuelle a').hide();
                $('footer.en_savoir_plus a').show();
            } else {
                $('footer.visite_virtuelle a').show();
                $('footer.en_savoir_plus a').hide();
            }

            // Si le polygon contient un ID, alors, on affiche la zone "condo viewer" (en retirant la classe "hidden")
            if ($(this).attr('data-shape-title')) {
                let condoPlanViewer = $(this).closest('.etage-item').find('.condo-plan-viewer');
                condoPlanViewer.removeClass('!w-0 !p-0 hidden');

                setTimeout(() => {
                    condoPlanViewer.find('main, header, footer').removeClass('opacity-0');
                }, 300);
            }
        });

        jQuery('.etage-item:first .etage-prev').fadeOut();
        jQuery('.etage-item:last .etage-next').fadeOut();

        jQuery('.etage-next').on('click', function() {
            var current = $(this).closest('.etage-item');
            current.fadeOut(function() {
                current.next('.etage-item').fadeIn();
            });
        });

        jQuery('.etage-prev').on('click', function() {
            var current = $(this).closest('.etage-item');
            current.fadeOut(function() {
                current.prev('.etage-item').fadeIn();
            });
        });
    }
};

// Le code ci-dessous regroupe les checkbox des formulaires dactive campaign dans une div pour pouvoir les styliser en CSS

jQuery(document).ready(function() {
    // Définir le nom de la classe parent
    var selector = 'activeCampaign';

    // Modifier les attributs placeholder des input enfants de 'div.activeCampaign'
    jQuery('div.' + selector + ' input#lastname').attr('placeholder', 'Nom*');
    jQuery('div.' + selector + ' input#firstname').attr('placeholder', 'Prénom*');
    jQuery('div.' + selector + ' input#email').attr('placeholder', 'Courriel*');
    jQuery('div.' + selector + ' input#phone').attr('placeholder', 'Téléphone*');
    jQuery('div.' + selector + ' textarea#field[32]').attr('placeholder', 'Message*');

    // Parcourir chaque élément fieldset avec la classe '_form-fieldset' qui est un enfant de 'div.activeCampaign'
    jQuery('div.' + selector + ' fieldset._form-fieldset').each(function() {
        // Créer la nouvelle div
        var newDiv = jQuery('<div>').attr('id', 'checkbox-radio-container');

        // Sélectionner les divs à englober (dans l'élément fieldset courant)
        var checkboxRadios = jQuery(this).find('div._checkbox-radio');

        // Déplacer chaque div dans la nouvelle div
        checkboxRadios.each(function() {
            newDiv.append(jQuery(this));
        });

        newDiv.prepend('<div class="hidden"></div>');

        // Ajouter la nouvelle div à la fin de l'élément fieldset courant
        jQuery(this).append(newDiv);
    });
});

// Le code ci-dessous permet d'ajouter dynamiquement l'icône de flèche dans le bouton de confirmation d'Active Campaign pour le bloc infolettre
jQuery(document).ready(function() {
    if (jQuery('div.bloc-infolettre').length) {
        let image = jQuery('img.arrow_infolettre');
        jQuery('div.bloc-infolettre button').addClass('!flex flex-row items-center').append(image);
    }

    jQuery('div.bloc-icones-avec-texte .icones-en-avant .item div div').matchHeight();
});

jQuery(document).ready(function() {
    // Ce code permet de styliser les input:file

    jQuery('input[type=file]').addClass('file-upload');

    jQuery('.file-upload').each(function() {
        // Créer les éléments
        var $wrapper = jQuery('<div>', {
            class: 'file-upload-wrapper flex flex-row rounded-lg border border-black p-3 cursor-pointer items-center',
            style: 'border: 1px dotted gray; border-radius: 0.5rem;',
        });
        var $img = jQuery('<img>', {
            src: 'https://stagingmedway.com/app/uploads/2023/05/download-pictogram.png',
            alt: 'Upload icon',
            class: 'custom-button-img mr-4',
        });
        var $span = jQuery('<span>', {
            text: 'Choisir un fichier',
            class: 'custom-text font-semibold',
        });

        // Ajouter limage et le span au wrapper
        $wrapper.append($img);
        $wrapper.append($span);

        // Ajouter le wrapper avant linput
        jQuery(this).before($wrapper);

        // Cacher linput dorigine
        jQuery(this).hide();

        // Lier les événements
        $wrapper.click(() => jQuery(this).click());

        jQuery(this).change(function() {
            if (jQuery(this).val()) {
                $span.text(
                    jQuery(this)
                        .val()
                        .match(/[/\\]([\w\d\s\.\-\(\)]+)$/)[1] // Corrected regex escape
                );
            } else {
                $span.text('Choisir un fichier');
            }
        });
    });
});

// Page condo et projet | Instabot - Déclenchement de la pop-up Calendly lorsque liframe transmet le event.data "openCalendly"
window.addEventListener('message', function(event) {
    // Vérifier que le message est celui que nous attendons
    if (event.data === 'openCalendly') {
        // On fait disparaître linterface dInstabot
        jQuery('div.roko-instabot-widget, div.roko-instabot-overlay, div.roko-instabot-close-chat-button, div.roko-instabot-widget-button').fadeOut();

        // On fait apparaître la pop-up Calendly
        jQuery('div.pop-up-calendly').fadeIn();
    }
});

// Code spécifique pour le formulaire activeCampaign des pages de condos & de projet
jQuery(document).ready(function() {
    if (jQuery('body').hasClass('single-projet') || jQuery('body').hasClass('single-condo')) {
        var legend = jQuery('div.activeCampaign form._form_5 legend._form-label:contains("Je recherche un*")');
        legend
            .css('cursor', 'pointer')
            .addClass('flex flex-row justify-between items-center')
            .append('<i class="fas fa-chevron-down transition-transform duration-200 ease-in-out transform rotate-180" style="margin-left: 10px; color: #886847"></i>')
            .on('click', function() {
                var container = jQuery('#checkbox-radio-container');
                var icon = jQuery('.fas.fa-chevron-down');
                if (container.is(':visible')) {
                    container.fadeOut('slow');
                    icon.removeClass('transform rotate-180');
                } else {
                    container.fadeIn('slow');
                    icon.addClass('transform rotate-180');
                }
            });
    }
});

// Aide pour le style custom des checkboxs
$(document).ready(function() {
    // Pour chaque checkbox
    $("body:not(.wp-admin) input[type='checkbox']").each(function() {
        // On ajoute un span avec la classe 'custom-checkbox' après la checkbox
        $(this).after("<span class='custom-checkbox'></span>");
    });

    // Ajoute un gestionnaire de clic pour le .custom-checkbox
    $('.custom-checkbox').on('click', function() {
        // Trouve la checkbox associée
        var checkbox = $(this).prev("input[type='checkbox']");

        // Change l'état de la checkbox (cochée/décochée)
        checkbox.prop('checked', !checkbox.prop('checked'));

        // Déclenche l'événement 'change' pour mettre à jour le style
        checkbox.change();
    });
});

// Formulaire Active Campaign - Lead commercial - Remplissage du champ caché (projet immobilier choisi)
jQuery(document).ready(function() {
    // Vérifier que le document soit complètement chargé

    var targetDiv = 'div.bloc-formulaires div.activeCampaign div._form_25';

    if (jQuery(targetDiv).length) {
        // Si le div cible est présent sur la page
        var nomProjetSpan = 'span#nom_projet'; // Sélecteur pour le span contenant le nom du projet

        // Récupérer le contenu textuel du span s'il est présent, sinon mettre la valeur à "Vide"
        var nomProjet = jQuery(nomProjetSpan).length ? jQuery(nomProjetSpan).text() : 'Vide';

        var targetInput = targetDiv + ' div._x65568821 input'; // Sélecteur pour linput cible

        jQuery(targetInput).val(nomProjet); // Assigner la valeur récupérée à linput cible
    }
});

// Formulaire Active Campaign - Lead commercial - Code demandé par MHDP pour fonctionnement de Google Tag Manager

if (jQuery('span#nom_projet').length) {
    // Vérifie si l'élément existe

    let nomProjet = jQuery('span#nom_projet').text(); // Récupère le texte de l'élément
    let typeProjet = jQuery('span#type_projet').text(); // Récupère le type de l'élément

    let formID;
    if (jQuery('._form_25').length) {
        formID = '_form_25';
    } else {
        formID = 'ID du formulaire de lead commercial non-trouvé';
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        ACformID: formID,
        project_type: typeProjet,
        project_name: nomProjet,
    });
}

// Formulaire Active Campaign - Tous
jQuery(document).on('mousedown', 'button._submit', function() {
    var formClass = jQuery(this).closest('div[class^="_form_"]').attr('class');
    var formID = formClass.match(/_form_(\d+)/)[1];

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        ACformID: formID,
    });
});

// Active Campaign - Formulaire de contact - Ajout du placeholder sur le select "Sujet"
jQuery(function() {
    var select = jQuery('div._x70224225._form_element select');
    jQuery('div._x70224225 label').hide();
    select.prepend('<option value="" disabled selected hidden>Sujet</option>');
    select.addClass('placeholderColor'); // On ajoute la classe ici

    select.on('change', function() {
        if (jQuery(this).val() !== '') {
            // On ne retire la classe que si une option est sélectionnée
            jQuery(this).removeClass('placeholderColor');
        }
    });
});

// Page d'offre d'emploi - Ajustement automatique de la hauteur des conteneurs de texte
jQuery(function($) {
    function adjustH4() {
        if ($('body').hasClass('single-offre-emploi')) {
            if ($(window).width() > 768) {
                var maxHeight = Math.max(
                    ...$('div.grid h4').map(function() {
                        return $(this).height('auto').height();
                    })
                );
                $('div.grid h4').height(maxHeight);
            } else {
                $('div.grid h4').height('auto');
            }
        }
    }
    adjustH4();
    $(window).resize(adjustH4);
});

jQuery(function($) {
    function adjustUserInfosHeight() {
        // Si la largeur de la fenêtre est supérieure à 640px, ajustez les hauteurs
        if ($(window).width() > 640) {
            var maxHeight = Math.max(
                ...$('div.bloc-thumbnails div.swiper-wrapper div.userInfos').map(function() {
                    return $(this).height('auto').height();
                })
            );
            $('div.bloc-thumbnails div.swiper-wrapper div.userInfos').height(maxHeight);
        }
        // Si la largeur de la fenêtre est inférieure ou égale à 640px, réinitialisez les hauteurs
        else {
            $('div.bloc-thumbnails div.swiper-wrapper div.userInfos').height('auto');
        }
    }

    // Appel initial de la fonction
    adjustUserInfosHeight();

    // Appeler la fonction chaque fois que la fenêtre est redimensionnée
    $(window).resize(adjustUserInfosHeight);
});

/* Clinique médicale */
jQuery(document).ready(function() {
    if (jQuery('#superStoreFinder.cliniques').length > 0) {
        var newContent = jQuery('<div class="bg-white hidden lg:flex flex-col px-5" />').html(`
            <h3 class="surTitre text-secondary-txt text-2xl md:text-surtitre md:leading-surtitre pt-5 pb-2">
                Chez Medway
            </h3>

            <h2 class="Titre text-3xl md:text-titre md:leading-titre font-semibold pb-5">
                Trouvez les cliniques médicales qui nous font confiance
            </h2>
    `);

        jQuery('div#super-left-panel').prepend(newContent);
        jQuery('.hide-for-small-down h2').remove();
    }
});

/* Locaux commerciaux */
jQuery(document).ready(function() {
    if (jQuery('#superStoreFinder.commerciaux').length > 0) {
        var newContent = jQuery('<div class="bg-white hidden lg:flex flex-col px-5" />').html(`
            <h3 class="surTitre text-secondary-txt text-2xl md:text-surtitre md:leading-surtitre pt-5 pb-2">
                Chez Medway
            </h3>

            <h2 class="Titre text-3xl md:text-titre md:leading-titre font-semibold pb-5">
                Trouvez les locaux commerciaux 
            </h2>
    `);

        jQuery('div#super-left-panel').prepend(newContent);
        jQuery('.hide-for-small-down h2').remove();

        const targetNode = document.getElementById('superStoreFinder');

        if (targetNode) {
            const observer = new MutationObserver(function(mutations) {
                const storeList = document.getElementById('storeLocator__storeList');
                if (storeList && storeList.innerHTML.includes('Aucune clinique trouvée à proximité.')) {
                    storeList.innerHTML = storeList.innerHTML.replace('Aucune clinique trouvée à proximité.', 'Aucun local trouvé à proximité.');
                    observer.disconnect(); // On a trouvé et remplacé, on peut arrêter d'observer
                }
            });

            observer.observe(targetNode, {
                childList: true,
                subtree: true
            });
        }
    }
});

/**
 * Image Map Pro - Visual indicator for unavailable units
 */
jQuery(document).ready(function() {
    if (jQuery('section.single-projet').length) {
        // Add cursor not-allowed for unavailable (red) polygons
        jQuery(document).on('mouseenter', 'div.etage-item polygon.imp-shape.fill-red', function() {
            jQuery(this).css('cursor', 'not-allowed');
        });

        jQuery(document).on('mouseleave', 'div.etage-item polygon.imp-shape.fill-red', function() {
            jQuery(this).css('cursor', '');
        });
    }
});

